/**
 * Models offered per provider. Kept client-side for the pilot; the Loom chat
 * page and the page-bound chat drawer (src/page-dsl/PageChatDrawer.tsx) both
 * pick from it, so a new model is added once.
 */
export const MODELS: Record<string, string[]> = {
  anthropic: ["claude-sonnet-5", "claude-opus-5", "claude-haiku-4-5"],
  openai: ["gpt-5.2", "gpt-5-mini"],
};

/** The default model for a provider: the first offered, "" for an unknown provider. */
export function defaultModelFor(provider: string): string {
  return MODELS[provider]?.[0] ?? "";
}
